export const greetings = [
  { text: "Hello", language: "English" },
  { text: "Sawubona", language: "Zulu" },
  { text: "Ndaa", language: "Hausa" },
  { text: "Salama", language: "Somali" },
  { text: "Bawo", language: "Yoruba" },
  { text: "Dumela", language: "Setswana" },
  { text: "Mhoro", language: "Shona" },
  { text: "Kóyo", language: "Igbo" },
    { text: "Jambo", language: "Swahili" }
];
